import React from 'react';
import { TaskExportConfiguration } from '../types/task_export_configuration/taskExportConfiguration';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { instanceToPlain } from 'class-transformer';

export interface TaskExportConfigurationContextProps {
  taskExportConfigurations: Map<string, TaskExportConfiguration>;
  setTaskExportConfigurations: (tasks: Map<string, TaskExportConfiguration>) => void;
  taskExportConfigurationsLoading: boolean;
}

const defaultContext: TaskExportConfigurationContextProps = {
  taskExportConfigurations: new Map(),
  setTaskExportConfigurations: () => {},
  taskExportConfigurationsLoading: false,
};

export const TaskExportConfigurationContext = React.createContext<TaskExportConfigurationContextProps>(defaultContext);

interface TaskExportConfigurationState {
  items: Record<string, any>[];
  loading: boolean;
}

export const taskExportConfigurationSlice = createSlice({
  name: 'taskExportConfiguration',
  initialState: { items: [], loading: true } as TaskExportConfigurationState,
  reducers: {
    reset: state => {
      state.items = [];
      state.loading = true;
    },
    setAll: (state, action: PayloadAction<TaskExportConfiguration[]>) => {
      state.items = action.payload.map(p => instanceToPlain(p));
    },
    addAll: (state, action: PayloadAction<TaskExportConfiguration[]>) => {
      const map = new Map([...state.items, ...action.payload.map(p => instanceToPlain(p))].map(pmd => [pmd.id, pmd]));
      state.items = [...map.values()];
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});
